module.exports = __webpack_public_path__ + "static/media/free.018bb1a3.svg";